import { FieldGuesser, InputGuesser, ListGuesser, ShowGuesser } from '@api-platform/admin'
import React from 'react'
import {
    Create as BaseCreate,
    Edit as BaseEdit,
    required,
    SaveButton,
    SimpleForm,
    Toolbar,
    SelectInput,
    useRecordContext,
    ReferenceField,
    FunctionField,
    ImageField,
    SingleFieldList,
    ReferenceArrayField,
    WrapperField,
    TextField,
    SimpleShowLayout,
    ChipField,
} from 'react-admin'
import ActionButton from '../action'

const Title = () => {
    const record = useRecordContext()

    return <span>{record ? `${record?.title}` : ''}</span>
}

const EditToolbar = (props) => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
)

const InputFields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <SimpleForm toolbar={<EditToolbar />}>
            <InputGuesser label='Title' source='title' fullWidth isRequired validate={[required()]} />
            <SelectInput
                fullWidth
                label='Status'
                source='status'
                choices={[
                    { id: 'pending', name: 'pending' },
                    { id: 'published', name: 'published' },
                    { id: 'rejected', name: 'rejected' },
                    { id: 'cancelled', name: 'cancelled' },
                ]}
                validate={[required()]}
            />
        </SimpleForm>
    </Guesser>
)

const Fields = ({ Guesser, children, ...props }) => (
    <Guesser {...props}>
        <FieldGuesser label='Title' source='title' />
        <ReferenceField label='Owner' source='user' reference='users' sortable={false}>
            <FunctionField render={(record) => record.fullName} />
        </ReferenceField>
        <ReferenceField label='Category' source='category' reference='categories' sortable={false}>
            <FunctionField render={(record) => record.name} />
        </ReferenceField>
        <FieldGuesser label='Type' source='type' />
        <FieldGuesser label='Status' source='status' />
        {children}
    </Guesser>
)

export const Create = (props) => <InputFields Guesser={BaseCreate} title={`CREATE`} {...props} />

export const Edit = (props) => <InputFields Guesser={BaseEdit} title={<Title />} {...props} />

export const Show = (props) => (
    <Fields Guesser={ShowGuesser} title={<Title />} {...props}>
        <ActionButton uri='publish' fromStatus={['pending']} label='Publier' />
        <ActionButton uri='cancel' fromStatus={['published', 'pending']} label='Annuler' />
        <ActionButton uri='reject' fromStatus={['pending']} label='Rejeter' />
        <FieldGuesser source='price' />
        <FieldGuesser source='description' />

        <ReferenceField source='address' reference='addresses'>
            <FunctionField render={(record) => record.fullName} />
        </ReferenceField>

        <ReferenceField source='job' reference='jobs'>
            <WrapperField>
                <SimpleShowLayout>
                    <TextField source='company' label='Company' />
                    <TextField source='experience' label='Experience' />
                    <TextField source='educationLevel' label='Education' />
                    <TextField source='minSalary' />
                    <TextField source='maxSalary' />
                    <ReferenceField source='domain' reference='domains'>
                        <FunctionField render={(record) => record.name} />
                    </ReferenceField>
                </SimpleShowLayout>
            </WrapperField>
        </ReferenceField>

        <ReferenceField source='vehicle' reference='vehicles'>
            <WrapperField>
                <SimpleShowLayout>
                    <ReferenceField source='model' reference='models'>
                        <WrapperField>
                            <SimpleShowLayout>
                                <FunctionField render={(record) => record.name} />
                                <ReferenceField source='marque' reference='marques'>
                                    <FunctionField render={(record) => record.name} />
                                </ReferenceField>
                            </SimpleShowLayout>
                        </WrapperField>
                    </ReferenceField>
                    <TextField source='fuel' />
                    <TextField source='transmission' />
                    <TextField source='year' />
                    <TextField source='mileage' />
                    <TextField source='power' />
                    <TextField source='type' />
                    <TextField source='nbOwner' />
                    <TextField source='nbSeet' />
                    <TextField source='dourCount' />

                    <ReferenceArrayField source='equipments' reference='equipments'>
                        <SingleFieldList>
                            <ChipField source='name' />
                        </SingleFieldList>
                    </ReferenceArrayField>
                </SimpleShowLayout>
            </WrapperField>
        </ReferenceField>

        <ReferenceArrayField source='medias' reference='medias' label='Images'>
            <SingleFieldList>
                <ImageField source='contentUrl' label='Cover' />
            </SingleFieldList>
        </ReferenceArrayField>
    </Fields>
)

export const List = (props) => <Fields Guesser={ListGuesser} {...props} />

const CRUD = {
    list: List,
    edit: Edit,
    show: Show,
}

export default CRUD
